import ApolloClient, {
	createNetworkInterface,
	toIdValue
} from "apollo-client";

import {
	scapholdURL,
} from "./consts";

import getJWT from "./getJWT";

const networkInterface = createNetworkInterface({
	uri: scapholdURL,
});

const dataIdFromObject = R.prop("id");

const customResolvers = {
	Query: R.pipe(
		R.map( (type) => ([
			"get" + type,
			(_, { id, ...rest,}) => (
				toIdValue(dataIdFromObject({ id, }))
		),
		])),

		R.fromPairs,
	)([
		"Module",
		"Doc",
		"Folder",
		"User",
	]),
};

	networkInterface.use([
		{
			applyMiddleware(req, next) {
				if (!req.options.headers) {
					req.options.headers = {};  // Create the header object if needed.
				}

				getJWT()
					.then( (jwt) => {

						req.options.headers.Authorization = `Bearer ${ jwt }`;

						next();
					})
			},
		},
	]);

export const client = new ApolloClient({
	networkInterface,
	customResolvers,
	dataIdFromObject,
	connectToDevTools: true,
});
